import { globalConstants, privacyPolicyConstants } from "../../constants";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { privacyPolicyService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom, success } from "./utilities";

const { ADD_OR_UPDATE_PRIVACY_POLICY, GET_PRIVACY_POLICY } =
  privacyPolicyConstants;

const addOrUpdatePrivacyPolicy = (data, successFunc) => (dispatch) => {
  dispatch(
    custom(ADD_OR_UPDATE_PRIVACY_POLICY, globalConstants.SPINNER_ACTIVATE)
  );
  privacyPolicyService
    .addOrUpdatePrivacyPolicy(data)
    .then(
      (response) => {
        customToast(response.msg, SUCCESS_TOAST);
        successFunc();
      },
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(ADD_OR_UPDATE_PRIVACY_POLICY, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const getPrivacyPolicy = () => (dispatch) => {
  dispatch(custom(GET_PRIVACY_POLICY, globalConstants.SPINNER_ACTIVATE));
  privacyPolicyService
    .getPrivacyPolicy()
    .then(
      (response) => dispatch(success(response, GET_PRIVACY_POLICY)),
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(GET_PRIVACY_POLICY, globalConstants.SPINNER_DIACTIVATE))
    );
};

export const privacyPolicyActions = {
  addOrUpdatePrivacyPolicy,
  getPrivacyPolicy,
};
